export default __webpack_public_path__ + "static/91b94f5f-a9f1-491a-a9fe-ffaa147523cd-a77e5213d82ec3c2213d763c51e778b5.woff";